import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    attachUserBlock: {
      marginTop: '40px',
    },
  }),
);

export default useStyles;
